export default __webpack_public_path__ + "static/home-skyline-4a778ad71817e074c0c4405e90ebd1ca.svg";